import { useMutation } from 'react-query'
import toastService from '@/components/toast/toast-service'
import { login } from '@/services/authentication'
import { TokenStorage } from '@/utils/token-storage'

interface UseLoginMutationOptions {
  onSpeRequired?: () => void
}

export function useLoginQueryMutation(options?: UseLoginMutationOptions) {
  return useMutation(login, {
    onSuccess: async data => {
      const isVrAccessContext = data?.isVrAccessContext || false
      if (isVrAccessContext) {
        return options?.onSpeRequired?.()
      }

      TokenStorage.storeToken(data.token.token)
    },
    onError: async () => {
      toastService.error('Login/Senha inválidos.')
    }
  })
}
